import { setActiveOfferId } from './setActiveOfferId';
import { toggleModal } from './toggleModal';
import { EListingModalMode, EOffersFetchingMode } from './types';
import { IPublicWebV1SearchResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { TFeatureWithCianId } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { loadListingOffers, removeOffers } from '../listingOffers';

export const setupListingModalSingleMode =
  (feature: TFeatureWithCianId): TThunkAction<Promise<IPublicWebV1SearchResponse>> =>
  dispatch => {
    dispatch(removeOffers());
    dispatch(setActiveOfferId(feature.properties.offers[0].cianId || -1));
    dispatch(
      toggleModal({
        open: true,
        mode: EListingModalMode.FULL_SCREEN,
        offersFetchingMode: EOffersFetchingMode.SINGLE,
      }),
    );

    return dispatch(loadListingOffers({ offersFetchingMode: EOffersFetchingMode.SINGLE }));
  };
